import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { changePage, submitMindfire, changeMicrofInfoValue } from '../../redux/actions/index';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import BackBtn from '../../components/UI/BackButton/BackButton';
import Button from '../../components/UI/Button/CustomButton';
import { reactGAPageview } from '../../helper';
import { MicrofFlowPageNumber } from './MicrofFlow';
import { Field, Form, withFormik } from 'formik';
import SelectWithCustomOnChange from '../../components/UI/Form/Select/SelectWithCustomOnChange';
import SystemTypesList from '../../assets/js/AieConditioningSystemTypesList';
import * as Yup from 'yup';

const SystemType = props => {
  const {
    email,
    dispatchChangePage,
    dispatchChangeMicrofInfoValue,
    dispatchSubmitMindfire,
    did,
    dealerUserId,
    systemType,
    pqi,
  } = props;

  useEffect(() => {
    reactGAPageview({
      path: '/ca_homeowner',
      trackerNames: [],
      title: 'ca_homeowner',
      did,
      dealerUserId,
    });

    // eslint-disable-next-line
  }, []);

  const handleSelectedPlan = value => {};

  const SystemTypeForm = ({ values }) => (
    <Form>
      <Field
        component={SelectWithCustomOnChange}
        label="Project Type"
        name="systemType"
        id="systemType"
        tooltipText={'Please select System Type'}
        type="select"
        selectValues={SystemTypesList}
        selectFirstName="Select One"
        handleChange={e => handleSelectedPlan(e.target.value)}
      />

      <Button type="submit" title="Next" />
    </Form>
  );

  const SystemTypeFormFormik = withFormik({
    mapPropsToValues: () => ({
      systemType: systemType ? systemType : '',
    }),

    validationSchema: Yup.object({
      systemType: Yup.string().required('Please select a Project Type.'),
    }),

    handleSubmit: values => {
      dispatchChangeMicrofInfoValue('systemType', values.systemType);
      dispatchChangePage(
        pqi?.isHomeowner === true || pqi?.isHomeowner === false
          ? MicrofFlowPageNumber.UserAddress
          : MicrofFlowPageNumber.Homeowner,
      );
      dispatchSubmitMindfire({
        email: email,
        borrowedAmount: values.borrowedAmount,
        lastPage: '9010',
        dealerUserId: dealerUserId,
        did: did,
      });
    },
  })(SystemTypeForm);

  return (
    <Container>
      <Row>
        <Col>
          <Row className="mb-5">
            <BackBtn changePage={dispatchChangePage} page={MicrofFlowPageNumber.AppSSN} />
            <Col sm="5">
              <h4>What type of project would you like to lease today?</h4>
            </Col>
            <Col sm="6">
              <SystemTypeFormFormik />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = state => ({
  pqi: state.preQualificationInformation,
  isHomeowner: state.microfInformation.isHomeowner,
  systemType: state.microfInformation.systemType,
  homeownerInsurance: state.microfInformation.homeownerInsurance,
  email: state.preQualificationInformation.email,
  isReview: state.aquaInformation.isReview,
  dealerUserId: state.auth.dealerUserId,
  did: state.auth.did,
});

const mapDispatchToProps = dispatch => ({
  dispatchChangePage: page => dispatch(changePage(page)),
  dispatchChangeMicrofInfoValue: (key, value) => dispatch(changeMicrofInfoValue(key, value)),
  dispatchSubmitMindfire: params => dispatch(submitMindfire(params)),
});

SystemType.propTypes = {
  dispatchChangePage: PropTypes.func,
  dispatchChangeAquaInfoValue: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SystemType);
